import { render, staticRenderFns } from "./SixMonth.vue?vue&type=template&id=90fa917c&scoped=true&"
import script from "./SixMonth.vue?vue&type=script&lang=js&"
export * from "./SixMonth.vue?vue&type=script&lang=js&"
import style0 from "./SixMonth.vue?vue&type=style&index=0&id=90fa917c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fa917c",
  null
  
)

export default component.exports